__turbopack_context__.v({
  "editButton": "N7sZvG_editButton",
  "fieldSection": "N7sZvG_fieldSection",
  "fieldSectionTitle": "N7sZvG_fieldSectionTitle",
  "fieldSectionValue": "N7sZvG_fieldSectionValue",
  "savedBanner": "N7sZvG_savedBanner",
  "sectionTitle": "N7sZvG_sectionTitle",
  "sheetContent": "N7sZvG_sheetContent",
  "sheetTitle": "N7sZvG_sheetTitle",
});
